// @flow

import React from 'react';
import { Helmet } from 'react-helmet';
import yoastDataToTags, { metaRobotsTag } from './atoms/yoast';
import { gtmAsScript, gtmAsHtml } from './atoms/gtm';
import type { Yoast } from '../../types/apiRoute';

type StateProps = {
  yoast: ?Yoast,
};

type OwnProps = {|
  cookiesAccepted?: boolean, // eslint-disable-line react/no-unused-prop-types
  gtmId: ?string,
  googleSiteVerification: string,
  siteName: string,
  language: string,
  themeColor: string,
  yoast: ?Yoast,
|};

type Props = OwnProps & StateProps;

const Meta = ({
  gtmId,
  googleSiteVerification,
  siteName,
  language,
  yoast,
  themeColor,
}: Props) => (
  <Helmet
    defaultTitle={siteName}
    titleTemplate={`%s | ${siteName}`}
  >
    <html lang={language} />
    <body className="wp-react" />
    <title>{yoast && yoast.yoast_wpseo_title}</title>
    <meta
      name="viewport"
      content="width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0"
    />
    <meta httpEquiv="X-UA-Compatible" content="ie=edge" />
    <meta name="theme-color" content={themeColor} />
    <meta name="google-site-verification" content={googleSiteVerification} />
    {yoast && metaRobotsTag(yoast['yoast_wpseo_meta-robots-noindex'], yoast['yoast_wpseo_meta-robots-nofollow'])}
    {yoast && yoastDataToTags(yoast)}
    {gtmId && gtmAsScript(gtmId)}
    {gtmId && gtmAsHtml(gtmId)}
  </Helmet>
);

Meta.defaultProps = {
  cookiesAccepted: false,
};

export default Meta;
